// Yetki kontrolü için yardımcı fonksiyonlar
export const hasPermission = (user, requiredRole) => {
  if (!user) return false;
  return user.role === requiredRole;
};

export const hasAnyRole = (user, roles) => {
  if (!user) return false;
  return roles.includes(user.role);
};

export const canAccessReports = (user) => {
  if (!user) return false;
  // Sadece yönetici ve planlamacı raporlara erişebilir
  return ['yonetici', 'planlamaci'].includes(user.role);
};

export const canAccessUsers = (user) => {
  if (!user) return false;
  // Sadece yönetici kullanıcılara erişebilir
  return user.role === 'yonetici';
};

export const canAccessWorkOrders = (user) => {
  if (!user) return false;
  // Tüm roller iş emirlerine erişebilir
  return ['yonetici', 'personel', 'teknisyen', 'planlamaci', 'musteri_temsilcisi'].includes(user.role);
};

export const canAccessCustomers = (user) => {
  if (!user) return false;
  // Tüm roller müşterilere erişebilir
  return ['yonetici', 'personel', 'teknisyen', 'planlamaci', 'musteri_temsilcisi'].includes(user.role);
};

export const canAccessElevators = (user) => {
  if (!user) return false;
  // Tüm roller asansörlere erişebilir
  return ['yonetici', 'personel', 'teknisyen', 'planlamaci', 'musteri_temsilcisi'].includes(user.role);
};

export const canAccessDashboard = (user) => {
  if (!user) return false;
  // Tüm roller dashboard'a erişebilir
  return ['yonetici', 'personel', 'teknisyen', 'planlamaci', 'musteri_temsilcisi'].includes(user.role);
};

export const canCreateWorkOrder = (user) => {
  if (!user) return false;
  // Yönetici, planlamacı ve müşteri temsilcisi iş emri oluşturabilir
  return ['yonetici', 'planlamaci', 'musteri_temsilcisi'].includes(user.role);
};

export const canEditWorkOrder = (user) => {
  if (!user) return false;
  // Yönetici, planlamacı ve teknisyen iş emri düzenleyebilir
  return ['yonetici', 'planlamaci', 'teknisyen'].includes(user.role);
};

export const canDeleteWorkOrder = (user) => {
  if (!user) return false;
  // Sadece yönetici iş emri silebilir
  return user.role === 'yonetici';
};

export const canAssignWorkOrder = (user) => {
  if (!user) return false;
  // Yönetici ve planlamacı iş emri atayabilir
  return ['yonetici', 'planlamaci'].includes(user.role);
};

export const getRoleDisplayName = (role) => {
  // Kume sunucudaki davet rolleriyle ayni olmali (server/routes/signup.js
  // VALID_ROLES); eksik bir rol davet ekraninda ham slug olarak gorunur.
  const roleNames = {
    'yonetici': 'Sistem Yöneticisi',
    'personel': 'Personel',
    'teknisyen': 'Teknisyen',
    'planlamaci': 'Planlamacı',
    'musteri_temsilcisi': 'Müşteri Temsilcisi',
    'muhasebe': 'Muhasebe',
    'bina_yoneticisi': 'Bina Yöneticisi'
  };
  return roleNames[role] || role;
};
